import React from "react";
import "./PolicyStudioIconButton.css";
import { MyTooltip } from "../../common/MyTooltip";

interface PolicyStudioIconButtonProps {
  iconSrc?: string;
  iconComponent?: React.ReactNode;
  alt: string;
  border: boolean;
  hover?: boolean;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  isPublic?: boolean;
  tooltipText?: string;
  isOnTop?: boolean;
}

export const PolicyStudioIconButton: React.FC<PolicyStudioIconButtonProps> = ({
  iconSrc,
  iconComponent,
  alt,
  border,
  hover = true,
  onClick,
  className = "",
  disabled = false,
  tooltipText,
  isOnTop = false,
}) => {
  return (
    <MyTooltip title={tooltipText}>
      <div
        className={`policy-studio-icon-button ${className} ${hover ? "" : "no-hover"} ${disabled ? "disabled" : ""} ${isOnTop ? "on-top" : ""}`}
        role="button"
        tabIndex={0}
        onClick={disabled ? undefined : onClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onClick();
          }
        }}
        style={{
            border: border ? "1px solid #ebecf0" : "none",
            borderRadius: "1000px",
            cursor: disabled ? "default" : "pointer",
          }}
      >
        {iconComponent && iconComponent}
        {iconSrc &&
          <img src={iconSrc} alt={alt} />
        }
      </div>
    </MyTooltip>
  );
};
